export default "__VITE_ASSET__IqysPZpP__"